import { Injectable } from "@angular/core";
import { AppConfigService as AppConfigServiceCore } from "core-kit";

@Injectable()
export class AppConfigService extends AppConfigServiceCore {}
